import { Component, OnInit, ViewChild } from '@angular/core';
import { SummaryComponent } from '../summary/summary.component';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css'],
})
export class NotesComponent implements OnInit {
  notes: string[];
  note: string;
  totalList: number = 0;
  message: any;

  @ViewChild(SummaryComponent) child:any;

  constructor() {
    this.notes = [];
    this.note = '';
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.message = this.child.messageSummary;
  }

  createNote() {
    if (this.validation()) {
      this.notes.push(this.note);
      this.note = '';
      this.totalList = this.notes.length;
    }
  }

  validation() {
    if (this.note == '') {
      alert('el campo no puede estar vacio');
      return false;
    }
    return true;
  }

  receiveMessage($event:any) {
    this.note = $event;
  }

  receiveSecondMessage($event:any) {
    this.note = $event;
  }
}
